import request from "@/utils/request";

export default function agentBatchSetCardDeviceType(data) {
    return request({
        url: `/user/card/agentBatchSetCardDeviceType`,
        method: 'post',
        data
    })
}
